(() => {
    angular
        .module('faqModule', ['ngAnimate', 'journey.canvas.srv'])
        .controller('faqCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', '$compile',  ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache, $compile) => {

            $rootScope.$watch('translate', (func) => {
                if(func) {
                    $scope.translate = func;
                }
            });

            $scope.cLang = helpers.readCookie('L') || 'english';

            $rootScope.$on('displayFAQ', (evt, faqViewName) => {
                $scope.faq = true;

                //If there link is coming from Empty listing home page. We dipslay overview section
                if (faqViewName) {
                    $scope.faqContent(faqViewName);
                };

                $rootScope.$emit('setBodyOverflow');
            });

            $scope.trustSrc = function(src) {
                return $sce.trustAsResourceUrl(src);
            };

            $scope.faqContent = (view) => {
                let url = {
                    english: {
                        overview: 'https://kb.benchmarkemail.com/what-is-automation-pro/',
                        strategy: 'https://kb.benchmarkemail.com/does-automation-pro-have-templates/',
                        basics: 'https://kb.benchmarkemail.com/how-to-use-the-canvas-in-automation-pro/',
                        tracking: 'https://kb.benchmarkemail.com/?s=Website+Engagement',
                        active: 'https://kb.benchmarkemail.com/?s=active+automation',
                        reports: 'https://kb.benchmarkemail.com/how-to-access-reports-in-automation-pro/'
                    },
                    spanish: {
                        overview: 'https://kb.benchmarkemail.com/es/what-is-automation-pro/',
                        strategy: 'https://kb.benchmarkemail.com/es/tiene-plantillas-automatizaciones-pro/',
                        basics: 'https://kb.benchmarkemail.com/es/como-usar-el-canvas-de-automatizaciones-pro/',
                        tracking: 'https://kb.benchmarkemail.com/es/?s=website+tracking',
                        active: 'https://kb.benchmarkemail.com/es/puedo-actualizar-o-cambiar-un-email-dentro-de-una-automatizacion-activa/',
                        reports: 'https://kb.benchmarkemail.com/es/con-acceder-a-los-informes-en-automatizaciones-pro/'
                    },
                    italian: {
                        overview: 'https://kb.benchmarkemail.com/it/che-cose-automazioni-pro/',
                        strategy: 'https://kb.benchmarkemail.com/it/ci-sono-dei-template-in-automazioni-pro/',
                        basics: 'https://kb.benchmarkemail.com/it/come-posso-usare-il-canvas-in-automazioni-pro/',
                        tracking: 'https://kb.benchmarkemail.com/it/?s=website+attivita',
                        active: 'https://kb.benchmarkemail.com/it/posso-modificare-o-cambiare-une-mail-in-unautomazione-attiva/',
                        reports: 'https://kb.benchmarkemail.com/it/come-posso-accedere-ai-reports-di-automazioni-pro/'
                    },
                    brazil: {
                        overview: 'https://kb.benchmarkemail.com/br/o-que-e-o-automation-pro/',
                        strategy: 'https://kb.benchmarkemail.com/br/o-automation-pro-possui-templates/',
                        basics: 'https://kb.benchmarkemail.com/br/how-to-use-the-canvas-in-automation-pro/',
                        tracking: 'https://kb.benchmarkemail.com/br/?s=website+engajamento',
                        active: 'https://kb.benchmarkemail.com/br/posso-atualizar-ou-alterar-um-email-dentro-de-uma-automacao-ativa/',
                        reports: 'https://kb.benchmarkemail.com/br/como-acessar-os-relatorios-no-automation-pro/'
                    },
                    japanese: {
                        overview: 'https://kb.benchmarkemail.com/jp/what-is-automation-pro/',
                        strategy: 'https://kb.benchmarkemail.com/jp/does-automation-pro-have-templates/',
                        basics: 'https://kb.benchmarkemail.com/jp/how-to-use-the-canvas-in-automation-pro/',
                        tracking: 'https://kb.benchmarkemail.com/jp/how-to-use-website-engagement-or-website-activity/',
                        active: 'https://kb.benchmarkemail.com/jp/can-i-update-or-change-an-email-in-an-active-automation/',
                        reports: 'https://kb.benchmarkemail.com/jp/how-to-access-reports-in-automation-pro/'
                    },
                    chinese: {
                        overview: 'https://kb.benchmarkemail.com/cn/what-is-automation-pro/',
                        strategy: 'https://kb.benchmarkemail.com/cn/does-automation-pro-have-templates/',
                        basics: 'https://kb.benchmarkemail.com/cn/how-to-use-the-canvas-in-automation-pro/',
                        tracking: 'https://kb.benchmarkemail.com/cn/?s=如何追踪网站活动',
                        active: 'https://kb.benchmarkemail.com/tw/can-i-update-or-change-an-email-in-an-active-automation/',
                        reports: 'https://kb.benchmarkemail.com/cn/how-to-access-reports-in-automation-pro/'
                    },
                    chineset: {
                        overview: 'https://kb.benchmarkemail.com/tw/what-is-automation-pro/',
                        strategy: 'https://kb.benchmarkemail.com/tw/does-automation-pro-have-templates/',
                        basics: 'https://kb.benchmarkemail.com/tw/how-to-use-the-canvas-in-automation-pro/',
                        tracking: 'https://kb.benchmarkemail.com/tw/?s=如何追蹤網站活動',
                        active: 'https://kb.benchmarkemail.com/tw/can-i-update-or-change-an-email-in-an-active-automation/',
                        reports: 'https://kb.benchmarkemail.com/tw/how-to-access-reports-in-automation-pro/'
                    },
                    french: {
                        overview: 'https://kb.benchmarkemail.com/fr/qu-est-ce-qu-automatisation-pro/',
                        strategy: 'https://kb.benchmarkemail.com/fr/est-ce-que-automatisation-pro-a-des-templates/',
                        basics: 'https://kb.benchmarkemail.com/fr/comment-utilser-automatisation-pro/',
                        tracking: 'https://kb.benchmarkemail.com/fr/?s=website+activite',
                        active: 'https://kb.benchmarkemail.com/fr/est-ce-possible-de-modifier-ou-actualiser-un-email-actif-dans-une-automatisation/',
                        reports: 'https://kb.benchmarkemail.com/fr/comment-acceder-aux-rapports-d-automatisation-pro/'
                    },
                    german: {
                        overview: 'https://kb.benchmarkemail.com/de/was-ist-die-profi-automatisierung/',
                        strategy: 'https://kb.benchmarkemail.com/de/gibt-es-auch-vorlagen-fur-die-profi-automatisierung/',
                        basics: 'https://kb.benchmarkemail.com/de/wie-nutze-ich-die-ubersicht-bei-der-profi-automatisierung/',
                        tracking: 'https://kb.benchmarkemail.com/de/?s=website+interagieren',
                        active: 'https://kb.benchmarkemail.com/de/kann-ich-eine-e-mail-in-einer-aktiven-automatisierung-andern-oder-ersetzen/',
                        reports: 'https://kb.benchmarkemail.com/de/wie-kann-man-die-berichte-der-profi-automatisierung-einsehen/'
                    }
                };

                window.open(url[$scope.cLang || 'english'][view], '_blank');
            };

            $scope.closeFaq = () => {
                $scope.faq = false;
                $rootScope.$emit('removeBodyOverflow');
            };
        }]);
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/faqController.js